module.exports = new __parcel__URL__("btc.588dd199.svg").toString();